import React from 'react';
import PropTypes from 'prop-types';
import Select from '../Select';
import styles from './RowsPerPage.module.scss';

export function RowsPerPage(props) {
  const { options, current, onChange } = props;

  const selectOptions = options.map((option) => ({
    value: option.toString(),
    label: option,
  }));

  return (
    <div className={styles.wrapper}>
      <label>
        Rows per page
        <Select
          options={selectOptions}
          value={current.toString()}
          onChange={(value) => onChange(Number(value))}
          inline
        />
      </label>
    </div>
  );
}

RowsPerPage.propTypes = {
  current: PropTypes.number.isRequired,
  options: PropTypes.arrayOf(PropTypes.number).isRequired,
  onChange: PropTypes.func.isRequired,
};
